import {
  useMyCustomersAutocomplete,
  useMyCustomersProbe,
} from '~/common/hooks';
import {
  SharedCustomerSelector,
  useCustomerChangeHandler,
} from '~/purchase/components';

function ContainerEligibleCustomerSelector() {
  const customersProbe = useMyCustomersProbe({ containerEligibleOnly: true });
  const fetchCustomers = useMyCustomersAutocomplete({
    containerEligibleOnly: true,
  });
  const onChange = useCustomerChangeHandler();

  return (
    <SharedCustomerSelector
      customersProbe={customersProbe}
      fetchCustomers={fetchCustomers}
      onChange={onChange}
    />
  );
}

export default ContainerEligibleCustomerSelector;
